import { render, staticRenderFns } from "./BatchCall.vue?vue&type=template&id=18d2670c&scoped=true"
import script from "./BatchCall.vue?vue&type=script&lang=js"
export * from "./BatchCall.vue?vue&type=script&lang=js"
import style0 from "./BatchCall.vue?vue&type=style&index=0&id=18d2670c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2670c",
  null
  
)

export default component.exports